import { ref, onValue } from "firebase/database";
import { rtdb } from "./firebaseClient";

// Subscribe to count of active players (last 60s)
export function onPlayersOnline(callback, windowMs = 60000) {
  const r = ref(rtdb, "/presence/players");
  return onValue(r, (snap) => {
    const data = snap.val() || {};
    const now = Date.now();
    const count = Object.values(data).filter(
      (p) => p && typeof p.lastPing === "number" && now - p.lastPing <= windowMs
    ).length;
    callback(count);
  });
}
